import { Injectable } from '@angular/core';

// Keyed by the route's matched path template (route.routeConfig.path per segment), not the
// resolved URL, since the resolved URL contains the literal id.
@Injectable({
	providedIn: 'root',
})
export class AccountScopedRouteFallbackService {
	private readonly fallbacks: Record<string, string> = {
		'mes/production-plans/:configId': 'mes/production-plan-admin',
		'mes/terminals/:terminalId': 'mes/terminal-administration',
	};

	public getFallback(routeTemplate: string): string | null {
		return this.fallbacks[routeTemplate] ?? null;
	}
}
